export default (number) => {
    if (number === undefined || number === null) {
        return null;
    }
    if (Number(number) === 0) {
        return '0.00';
    }

    const bits = (1 * number).toFixed(2).split('.');
    const bobs = bits[0].replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$&,');
    return '$' + bobs + '.' + bits[1];

}
